import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './header/header';
import Footer from './footer/footer'
import MainPage from './pages/main_page/main_page';
import SobreNosotros from './pages/sobre_nosotros/sobre_nosotros';
import CentroQuiropractico from './pages/centro_quiropractico/centro_quiropractico';
import DosierCientifico from './pages/dosier_cientifico/dosier_cientifico'
import AvisoLegal from './pages/aviso_legal/aviso_legal';
import PoliticaCookies from './pages/cookies_policy/cookies_policy';
import PoliticaPrivacidad from './pages/privacy_policy/privacy_policy'

function App() {
    const [selectedPage, setSelectedPage] = useState(1);

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when selectedPage changes
    }, [selectedPage]);

  return (
      <div className="App">
          <Header selectedPage={selectedPage} setSelectedPage={setSelectedPage} /> 
          {selectedPage === 1 ? <MainPage /> : null}
          {selectedPage === 2 ? <SobreNosotros /> : null}
          {selectedPage === 3 ? <CentroQuiropractico /> : null}
          {selectedPage === 4 ? <DosierCientifico /> : null}
          {selectedPage === 5 ? <AvisoLegal /> : null}
          {selectedPage === 6 ? <PoliticaPrivacidad /> : null}
          {selectedPage === 7 ? <PoliticaCookies /> : null}
          <Footer setSelectedPage={setSelectedPage} />
    </div>
  );
}

export default App;
